module.exports = __webpack_public_path__ + "img/logo_at_branca.e604b46c.png";